import styled from 'styled-components';

export const WidgetWrapper = styled.div`
  position: fixed;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
`;

export const WidgetButton = styled.button`
  background: ${props => props.theme.colors.darkGreen};
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: ${props => props.theme.shadows.medium};
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }

  svg {
    font-size: 24px;
  }
`;

export const WidgetMenu = styled.div`
  position: absolute;
  right: 60px;
  top: 50%;
  transform: translateY(-50%);
  background: white;
  border-radius: ${props => props.theme.borderRadius.medium};
  padding: 1rem;
  box-shadow: ${props => props.theme.shadows.large};
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
  min-width: 200px;
`;

export const MenuTitle = styled.h3`
  color: ${props => props.theme.colors.darkGreen};
  margin-bottom: 1rem;
  text-align: center;
  font-size: ${props => props.theme.fontSizes.medium};
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid ${props => props.theme.colors.lightGray};
  margin: 0.5rem 0;
`;

export const MenuItem = styled.button`
  width: 100%;
  padding: 0.8rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: ${props => props.theme.colors.text};
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: ${props => props.theme.borderRadius.small};
  font-size: ${props => props.theme.fontSizes.medium};

  &:hover {
    background: ${props => props.theme.colors.lightGray};
  }

  &:last-child {
    color: ${props => props.theme.colors.brown};
    font-weight: ${props => props.theme.fontWeights.medium};
  }

  svg {
    font-size: 20px;
    color: ${props => props.theme.colors.brown};
  }
`; 